<template>
	<div class="body">
		<Head2></Head2>
		<div class="pageArea">
				<div class="sortTitle">{{$t('pages.download.sort_title')}}</div>
			<div class="containerArea">
			<div class="pageLeft">				
				<div class="treeList">
					<router-link :to="{path:'/download'}">
					<div class="allList">{{$t('pages.download.all_list')}}</div>
					</router-link>
					<div>
							<ul>
								<li v-for="(item, index1) in firstList" :key="item.id">
									<div class="title" :class="{active: item.is_show}">
										<router-link :to="{path:'/download',query:{id:item.id}}">
											<div class="title_width_1">{{item.title}}</div>
										</router-link>
										<img  src="../assets/images/rightArrowGray.png" class="rightArrowGray" v-if="item.is_show" @click="itemClick(item)"/>
										<img  src="../assets/images/bottomArrowGray.png" class="bottomArrowGray" v-else  @click="itemClick(item)"/>
									</div>
									<ul v-if="item.is_show">
										<li v-for="(subitem,index2) in secondList.filter(p=>p.parent_id==item.id)">
											<div v-if="subitem.title" class="subTitle" @click="itemClick(subitem)">
												<router-link :to="{path:'/download',query:{id:subitem.id}}">
											<div class="title_width_2">{{subitem.title}}</div>
											</router-link>
											<img  src="../assets/images/rightArrowGray.png"  class="rightArrowGray" v-if="subitem.is_show"/>
											<img  src="../assets/images/bottomArrowGray.png"  class="bottomArrowGray" v-else/>
											</div>
											<ul v-if="subitem.is_show" class="ssubUl" :class="{active: item.is_show}">
												
												<li v-for="(sub2,index3) in thirdList.filter(p=>p.parent_id==subitem.id)">
												<router-link :to="{path:'/download',query:{id:sub2.id}}">
													<div class="title_width_3">{{sub2.title}}	</div>
												</router-link>
												
												</li>

											</ul>
										</li>							
									</ul>
								</li>
							</ul>
					</div>
				</div>
			</div>
			<div class="pageRight">
                <div class="between">
			                    <div class="rightTitle"><div class="titleLine"></div>{{$t('pages.download.page_title')}}</div>

			                  <div class="searchArea">
			                    <input type="text"  v-model="keywords" :placeholder="$t('pages.download.search_placeholder')" />
			                    <div class="searchBtn" @click="search()">{{$t('pages.download.search_btn')}}</div>
			                </div>

                    </div>
				<div class="rightLayout">               
					<div class="rightSunTitle" v-if="thirdCateName!=''">{{firstCateName}}  >  {{secondCateName}}   >  {{thirdCateName}}</div>
					<div class="rightSunTitle" v-else-if="secondCateName!=''">{{firstCateName}}  >  {{secondCateName}}  </div>
					<div class="rightSunTitle" v-else>{{firstCateName}}  </div>			
					<div class="rightProLists">
						<div v-for="(item,index) in cateList" class="rightPro" @click="downloadFile(item)">
							<img :src="item.cover_images" class="proImgRight"/>
							<div class="proText">{{item.name}}</div>
		                            <div class="downBtn">{{$t('pages.download.download_btn')}}</div>
						</div>

					</div>
				</div>
			</div>
			</div>

		</div>
		<Foot2></Foot2>
	</div>
</template>

<script>
	import Head2 from '../components/head2.vue';
	import Foot2 from '../components/foot2.vue';
    import PaginationVue from '../components/pagination.vue';
		export default{
			components:{
				Head2,
				Foot2,
                PaginationVue
			},
			data() {
				return {
                   firstList:[],
				   secondList:[],
				   thirdList:[],
				   keywords:"",
				   firstCateName:"",
				   secondCateName:"",
				   thirdCateName:"",
				   cateList:[],
				}
			},
			created()
			{
				this.cateId= this.$route.query.id;
				this.keywords=this.$route.query.keywords;
				this.getCateList();
				this.getSampleBookList();
			},
			methods:{
				itemClick(item){
					item.is_show = !item.is_show;
				},
				getSampleBookList() {
					this.cateList=[];
					this.$scUtil.axiosPost(this, 'CategoryApi/GetSampleBook', {
						parent_id: this.cateId,
						keywords:this.keywords
						
					}, res => {
						console.log(res.code);
						if (res.code == 100) {
							this.cateList = res.data;
						}
				
					});
				},	
				downloadFile(item){
					//console.log(item.detail_files[0].url)
				    var a = document.createElement('a') // 创建一个<a></a>标签
				    a.href = item.detail_files[0].url         //重点（如测试发现下载文件不存在/找不到，检查路径）
				    a.download = item.name          // 设置下载文件文件名
				    a.style.display = 'none'           // 隐藏a标签
				    document.body.appendChild(a)       // 将a标签追加到文档对象中
				    a.click()                          // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
				    a.remove()
				},
				search() {
						let searchid=this.cateId;
						if(searchid!=undefined){
							this.$router.push({ path:'/download' , query:{id:searchid,keywords:this.keywords}});
						}else{
							this.$router.push({ path:'/download' , query:{keywords:this.keywords}});
						}				

				},
				getCateList() {
					this.$scUtil.axiosPost(this, 'CategoryApi/GetCategoryTreeList', {
						cateId: this.cateId,
						
					}, res => {
						if (res.code == 100) {
							res.data.forEach(item => {
								if(item.is_show=='1')
								{
									if(item.level==1)
									{
										this.firstCateName=item.title;
									}
									if(item.level==2)
									{
										this.secondCateName=item.title;
									}
									if(item.level==3)
									{
										this.thirdCateName=item.title;
									}
									//console.log(2);
									item.is_show=true;
								}else
								{
									//console.log(3);
									item.is_show=false;
								}
							});
							this.firstList = res.data.filter(p=>p.level==1);
							this.secondList = res.data.filter(p=>p.level==2);
							this.thirdList = res.data.filter(p=>p.level==3);
						}
				
					});
				}
			}
		}
</script>

<style scoped>
	.body{
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #ebecee;
	}
	.pageArea{
		width:1200px;
	}

	.sortTitle{
		font-size: 13px;
		color: #333333;
		height: 44px;
		line-height: 44px;
	}

	.pageLeft{
		width:238px;
		margin-right: 20px;
		display: flex;
		flex-direction: column;
	}

	
	.treeList{
		width: 236px;
		border: 1px solid #e6e6e6;
		background-color: #fff;
		margin-top: 20px;
		display: flex;
		flex-direction: column;
	}

	.allList{
		font-size: 15px;
		height: 37px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #0380fe;
		color: #fff;
	}

	ul li{
		list-style: none;
	}

	.treeList ul li {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		box-sizing: border-box;
	}

	.title,.subTitle{
		display: flex;
		justify-content: space-between;
		height: 35px;
		align-items: center;
     
	}   

	.title{
		width: 189px;
		font-size: 14px;
		color: #000000;
		cursor: pointer;
		padding: 0 22px 0 25px;
	}

	.subTitle{
		width: 236px;
		font-size: 14px;
		color: #666666;
		cursor: pointer;
		padding: 0 22px 0 50px;
		box-sizing: border-box;
        background: #ebecee;
	}

	.rightArrowGray{
			width: 5px;
			height: 8px;
	}

	.bottomArrowGray{
		width: 8px;
		height: 5px;
	}

	.ssubUl li{
		font-size: 14px;
		color: #888;
		height: 35px;
		line-height: 35px;
		cursor: pointer;
		padding: 0 22px 0 75px;
		width: 236px;
		box-sizing: border-box;
		display: inline-block;
	}

	.title.active{
		background-color: #e5f2ff;
	}

	.ssubUl li:hover{
        color: #0380fe;
        cursor: pointer;
    }

	.containerArea{
		display: flex;
		margin-bottom: 20px;
	}

	.pageRight{
		flex: 1;
		background-color: #fff;
		padding: 0 28px;
		box-sizing: border-box;
	}

	.rightTitle{
		height: 60px;
	
		font-size: 14px;
		color: #000000;
		display: flex;
		align-items: center;
	}

	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 10px;
	}

	.rightSunTitle{
		font-size: 13px;
		color: #333333;
		height: 50px;
		line-height: 50px;
	}

	.rightProLists{
		display: flex;
		flex-wrap: wrap;
	}

	.proImgRight{
		width: 130px;
		height: 130px;
        border: 1px solid #efefef;
        margin-bottom: 10px;
	}

	.proText{
		font-size: 14px;
		color: #666666;
        text-align: center;
        margin-bottom: 10px;
	}

	.rightPro{
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 12px;
		margin-bottom: 12px;
        justify-content: center;
	}

    .rightPro:hover .proImgRight{
        border: 1px solid #0380fe;
    }

    .rightPro:hover{
        cursor: pointer;
    }
    
    .rightPro:hover .proText{
       color: #0380fe;
    }

    .rightPro:hover .downBtn{
       color: #fff;
       background: #0380fe;
    }

	.rightPro:nth-child(6n+6){
		margin-right: 0;
	}

	.rightLayout{
		margin-bottom: 12px;
	}

    .rightSunTitle span{
        color: #0380fe;
    }

    .downBtn{
        width: 100px;
        height: 26px;
        background: #ebecee;
        border-radius: 5px;
        font-size: 12px;
        color: #000;
        text-align: center;
        line-height: 26px;
    }
    
	.paginationArea{
		width: 100%;
		padding: 10px 0 20px 0;
		display: flex;
		justify-content: center;
	} 

    .between{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e2e2e2;
        align-items: center;
    }

    .searchArea{
        width: 400px;
        height: 28px;
        border: 1px solid #0380fe;
        display: flex;
        align-items: center;
    }

    .searchBtn{
        width: 83px;
        height: 28px;
        background: #0380fe;
        color: #fff;
        text-align: center;
        line-height: 28px;
        font-size: 12px;
    }

    .searchArea input{
        width: 320px;
        border: none;
        padding-left: 10px;
    }

    .searchArea input{
        outline: none;
    }
</style>